import { Box, Button, Modal, Sheet, Typography } from "@mui/joy";
import { useDialogKeyboard } from '../../../hooks/useDialogKeyboard';

const DeleteApiKeyModal = ({ open, onClose, keyToDelete, onConfirmDelete }) => {
  const handleConfirm = async () => {
    if (keyToDelete) {
      await onConfirmDelete(keyToDelete.id);
      onClose();
    }
  };

  useDialogKeyboard(open, { onEnter: handleConfirm, onEscape: onClose });

  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
    >
      <Sheet
        variant="outlined"
        sx={{ maxWidth: 400, borderRadius: "md", p: 3, boxShadow: "lg", bgcolor: "background.surface" }}
      >
        <Typography level="h5" mb={1}>
          Confirm Delete
        </Typography>
        <Typography level="body-sm" mb={2}>
          Are you sure you want to delete the API key "{keyToDelete?.name}"?
          This action cannot be undone.
        </Typography>
        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}>
          <Button variant="plain" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="solid" color="danger" onClick={handleConfirm}>
            Delete
          </Button>
        </Box>
      </Sheet>
    </Modal>
  );
};

export default DeleteApiKeyModal;
